import { links } from 'utils/featureToggles'

import { PermissionDto } from './api/Identity/Types/PermissionDto'
import { PermissionsEnum } from './api/Identity/Types/PermissionsEnum'

const RoutesPermissions: Record<string, PermissionsEnum> = {
  [links.recordsAffiliates.url]: PermissionsEnum.CanBrowseAffiliates,
  [links.recordsClients.url]: PermissionsEnum.CanBrowseClients,
  [links.recordsWallets.url]: PermissionsEnum.CanBrowseWallets,
  [links.recordsTradingAccounts.url]: PermissionsEnum.CanBrowseTradingAccounts,
  [links.recordsWelcomeAccounts.url]: PermissionsEnum.CanBrowseWelcomeAccounts,
  [links.recordsDemoAccounts.url]: PermissionsEnum.CanBrowseDemoAccounts,
  [links.recordsAccountGroups.url]: PermissionsEnum.CanBrowseAccountGroups,
  [links.recordsIntroducingBrokers.url]: PermissionsEnum.CanBrowseIntroducingBrokers,
  [links.recordsPaymentAgents.url]: PermissionsEnum.CanBrowsePaymentAgents,
  [links.recordsExchangeRates.url]: PermissionsEnum.CanBrowseExchangeRates,
  [links.recordsCurrencyMarkups.url]: PermissionsEnum.CanEditMarkup,
  [links.brokerageIBProfiles.url]: PermissionsEnum.CanBrowseIntroducingBrokerProfiles,
  [links.brokerageBulkRestrictions.url]: PermissionsEnum.CanAddBulkRestrictions,
  [links.brokerageInstruments.url]: PermissionsEnum.CanBrowseInstruments,
  [links.brokerageDividends.url]: PermissionsEnum.CanEditDividendPayments,
  [links.brokeragePlatformsMT4Swaps.url]: PermissionsEnum.CanUpdateMetatrader4Settings,
  [links.brokeragePlatformsMT5Swaps.url]: PermissionsEnum.CanUpdateMetatrader5Settings,
  [links.brokeragePlatformsMT5Sessions.url]: PermissionsEnum.CanUpdateServerSessions,
  [links.brokeragePlatformsConfiguration.url]: PermissionsEnum.CanViewTickmillCompanyPlatformTypes,
  [links.brokerageDeals.url]: PermissionsEnum.CanBrowseDeals,
  [links.brokerageReferralsRestrictions.url]: PermissionsEnum.CanBrowseTickmillCompanyReferrals,
  [links.ticketsPayments.url]: PermissionsEnum.CanBrowsePaymentsTickets,
  [links.ticketsBackoffice.url]: PermissionsEnum.CanBrowseBackofficeTickets,
  [links.ticketsCompliance.url]: PermissionsEnum.CanBrowseComplianceTickets,
  [links.ticketsTranslation.url]: PermissionsEnum.CanBrowseTranslationsTickets,
  [links.ticketsBrokerage.url]: PermissionsEnum.CanBrowseBrokerageTickets,
  [links.ticketsSales.url]: PermissionsEnum.CanBrowseSalesTickets,
  [links.ticketsMyTickets.url]: PermissionsEnum.CanViewTicket,
  [links.transactionWalletAdjustments.url]: PermissionsEnum.CanBrowseCustomUserWalletTransactions,
  [links.transactionWallet.url]: PermissionsEnum.CanBrowseCrossWalletTransactions,
  [links.transactionPlatform.url]: PermissionsEnum.CanBrowseWalletTradingAccountTransactions,
  [links.transactionDepositWithdrawal.url]:
    PermissionsEnum.CanBrowseWalletDepositWithdrawalTransactions,
  [links.transactionIBCommissions.url]: PermissionsEnum.CanBrowseIBCommissionsTransactions,
  [links.transactionIBCashBacks.url]: PermissionsEnum.CanBrowseIBCommissionsTransactions,
  [links.transactionIBCashbackSettings.url]: PermissionsEnum.CanViewRebatePolicies,
  [links.transactionTradingAccountAdjustments.url]:
    PermissionsEnum.CanBrowseTradingAccountAdjustments,
  [links.transactionBonus.url]: PermissionsEnum.CanBrowseBonusTransactions,
  [links.transactionPaymentAgent.url]: PermissionsEnum.CanBrowsePaymentAgentTransactions,
  [links.transactionUnsubscribeRequests.url]:
    PermissionsEnum.CanViewSubscriptionRequestCancellations,
  [links.createTransaction.url]: PermissionsEnum.CanCreateTransactions,
  [links.createETDTransaction.url]: PermissionsEnum.CanCreateTransactions,
  [links.complianceCountryRisk.url]: PermissionsEnum.CanViewComplianceCountryRisk,
  [links.disclaimerLossPercentage.url]: PermissionsEnum.CanBrowseLossPercentage,
  [links.complianceWorldCheckCases.url]: PermissionsEnum.CanViewWorldCheckResults,
  // [links.complianceWorldCheckCases.url]: PermissionsEnum.CanViewWorldCheckResults,
  [links.productVersions.url]: PermissionsEnum.CanBrowseVersions,
  [links.productFeatureFlags.url]: PermissionsEnum.CanBrowseFeatureFlags,
  [links.productPlatformVersions.url]: PermissionsEnum.CanBrowsePlatformVersions,
  [links.administrationUsers.url]: PermissionsEnum.CanViewUsers,
  [links.administrationUserTeams.url]: PermissionsEnum.CanBrowseUserTeams,
  [links.administrationRoles.url]: PermissionsEnum.CanBrowseRoles,
  [links.administrationTeams.url]: PermissionsEnum.CanBrowseTeams,
  [links.administrationCountries.url]: PermissionsEnum.CanViewCountryConfiguration,
  [links.administrationWallets.url]: PermissionsEnum.CanViewWalletConfiguration,
  [links.administrationRateMarkups.url]: PermissionsEnum.CanBrowseRateMarkups,
  [links.administrationSubscriptions.url]: PermissionsEnum.CanViewSubscriptions,
  [links.administrationTradingAccounts.url]: PermissionsEnum.CanViewTradingAccountConfiguration,
  [links.administrationProducts.url]: PermissionsEnum.CanViewTradingAccountConfiguration,
  [links.administrationAllowedPaymentProvidersMatrix.url]: PermissionsEnum.CanBrowsePspGroups,
  [links.administrationAllowedPaymentProvidersUncovered.url]: PermissionsEnum.CanBrowsePspGroups,
  [links.administrationPaymentControlsPSPCheckState.url]:
    PermissionsEnum.CanViewPaymentProviderOptions,
  [links.sglLinkGenerator.url]: PermissionsEnum.CanGenerateSGLUrl,
  [links.ibLanding.url]: PermissionsEnum.CanBrowsePromoMaterials,
  [links.referralMaterials.url]: PermissionsEnum.CanViewReferralMaterials,
  [links.referralMaterialsCategories.url]: PermissionsEnum.CanViewReferralMaterials,
  [links.administrationInterestRateConfigControls.url]:
    PermissionsEnum.CanBrowseClientsInterestRates,
  [links.administrationInterestRateThresholds.url]: PermissionsEnum.CanBrowseClientsInterestRates,
  [links.administrationInterestRateEligibility.url]: PermissionsEnum.CanBrowseClientsInterestRates,
  [links.ibLandingPage.url]: PermissionsEnum.CanBrowsePromoMaterials,
  [links.bonusModule.url]: PermissionsEnum.CanBrowseBonusCampaigns,
  [links.referralMaterialsPage.url]: PermissionsEnum.CanViewReferralMaterials,
  [links.marketingNotifications.url]: PermissionsEnum.CanViewNotifications,
  [links.administrationPlatformLinks.url]: PermissionsEnum.CanBrowsePlatformLinks,
  [links.administrationContactDetails.url]: PermissionsEnum.CanViewContactDetails,
  [links.administrationPaymentProvidersConfig.url]: PermissionsEnum.CanBrowsePaymentProviders,
  [links.administrationPaymentProvidersOrdering.url]: PermissionsEnum.CanBrowsePaymentProviders,
  [links.emails.url]: PermissionsEnum.CanPreviewEmails,
  [links.complianceAppropriatenessTests.url]: PermissionsEnum.CanBrowseAppropriatenessTest,
  [links.rewardTypeManager.url]: PermissionsEnum.CanViewRewards,
  [links.rewardPrograms.url]: PermissionsEnum.CanViewRewards,
  [links.administrationMlWithdrawalAutomationGlobalControls.url]:
    PermissionsEnum.CanViewMLWithdrawalAutomationSettings,
  [links.administrationMlWithdrawalAutomationOverrides.url]:
    PermissionsEnum.CanViewMLWithdrawalAutomationSettings,
  [links.administrationWithdrawalThresholds.url]: PermissionsEnum.CanViewPaymentProviderThresholds,
}

export function isRouteAllowed(route: string, permissions: PermissionDto[]): boolean {
  return !!RoutesPermissions[route] && !!permissions.find((x) => x.id === RoutesPermissions[route])
}
